import React, { Component } from 'react';
import { Spinner, Pagination } from 'react-bootstrap';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import './PDFShow.scss';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

class PDFShow extends Component {
  state = {
    numPages: null,
    pageNumber: 1,
  }
 
  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
  }

  onChangePage = (type) => {
    const { pageNumber, numPages } = this.state;

    switch (type) {
      case 'first':
        this.setState({ pageNumber: 1 });
        break;
      case 'last':
        this.setState({ pageNumber: numPages });
        break;
      case 'prev':
        this.setState({ pageNumber: Math.max(1, pageNumber - 1) });
        break;
      case 'next':
        this.setState({ pageNumber: Math.min(pageNumber + 1, numPages) });
        break;
      default:
        break;
    }
  }
 
  render() {
    const { pageNumber, numPages } = this.state;
 
    return (
      <div className="pdf-wrapper">
        <div className="pdf-footer">
          <Pagination>
            <Pagination.First onClick={() => this.onChangePage('first')} />
            <Pagination.Prev onClick={() => this.onChangePage('prev')} />
            <Pagination.Item disabled>Page {pageNumber} of {numPages}</Pagination.Item>
            <Pagination.Next onClick={() => this.onChangePage('next')} />
            <Pagination.Last onClick={() => this.onChangePage('last')} />
          </Pagination>
        </div>
        <Document
          file={this.props.url}
          onLoadSuccess={this.onDocumentLoadSuccess}
          error="No preview available"
          className="h-100"
          loading={<Spinner animation="grow" variant="primary" className="position-absolute" />}
        >
          <Page pageNumber={pageNumber} />
        </Document>
        
      </div>
    );
  }
}

export default PDFShow;
